<template>
  <section id="trilhas" style="padding-left: 0; padding-right: 0; padding-top: 6rem">
    <div class="trails-header reveal" style="padding: 0 4rem">
      <div class="section-tag" style="justify-content: center">{{ sectionData.tag }}</div>
      <h2 class="section-title">
        {{ sectionData.titlePrefix }}<br /><span class="green">{{ sectionData.titleAccent }}</span>
      </h2>
    </div>

    <div class="trails-grid reveal" style="transition-delay: 0.2s">
      <div v-for="trail in sectionData.cards" :key="trail.id" class="trail-card">
        <div
          class="trail-card-bg"
          :class="trail.fallbackClass"
          :style="getTrailBackgroundStyle(trail)"
        ></div>

        <div class="trail-card-content">
          <span class="trail-level" :class="trail.levelClass">{{ trail.level }}</span>
          <div class="trail-name">{{ trail.name }}</div>
          <div class="trail-info">
            <span><i class="fa-solid fa-route"></i> {{ trail.distance }}</span>
            <span><i class="fa-solid fa-van-shuttle"></i> {{ trail.type }}</span>
            <span><i class="fa-solid fa-map-pin"></i> {{ trail.location }}</span>
          </div>
        </div>

        <div class="trail-arrow"><i class="fa-solid fa-arrow-right"></i></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TrailsSection",
  props: {
    sectionData: {
      type: Object,
      required: true
    }
  },
  methods: {
    getTrailBackgroundStyle(trail) {
      if (!trail.backgroundImage) {
        return null;
      }

      return {
        backgroundImage: `url('${trail.backgroundImage}')`,
        backgroundSize: "cover",
        backgroundPosition: trail.backgroundPosition || "center"
      };
    }
  }
};
</script>
